module.exports = {
     url: "https://261ydft4sa.execute-api.us-west-2.amazonaws.com/dev/"
   //  url : "http://localhost:3000/dev/"
}